import { createLogger, createStore } from 'vuex'
import me from './modules/me'
import tenant from '@/store/modules/tenant'
import theme from '@/store/modules/theme'
import aiChats from '@/store/modules/aiChats'
import aiRequests from '@/store/modules/aiRequests'
import aiSwitch from '@/store/modules/aiSwitch'

export default createStore({
  modules: {
    me,
    tenant,
    theme,
    aiChats,
    aiRequests,
    aiSwitch,
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: process.env.NODE_ENV !== 'production' ? [createLogger()] : [],
})
